

export const transformBackFormatDBMultiple = (moduleTopics) => {

    return moduleTopics.map(moduleTopic => {
        // Extract the topic name and corresponding chips  
        const topicName = Object.keys(moduleTopic.topic)[0]; // Get the topic name  
        const chipTexts = moduleTopic.topic[topicName]; // Get the array of chip texts  

        // Map chips back to their original structure  
        const topicChips = chipTexts.map(text => ({
            id: Date.now().toString(), // Generate a new id; in a real scenario, you would probably need a different approach to get the correct ID if needed.  
            text: text
        }));

        return {
            id: Date.now().toString(), // Generate a new id for the topic  
            topicName: topicName,
            topicChips: topicChips
        }
    });

};




export const convertDBTopicsMultiple = (input) => {
    return {
        moduleTopics: input.topics.map(topic => ({
            topic: {
                [topic.topicName]: topic.topicChips.map(chip => chip.text) // Map chips to their texts  
            }
        })),
    };
}; 



/**  
 * Converts a structured input array into a specific moduleTopics format.  
 * @param {Array} topicsArray - An array of topic objects.  
 * @returns {Object} - A flat object structure containing module topics.  
 */  
export function convertToDBModuleTopicsForSingle(topicsArray:any) {   
    return {  
        moduleTopics: {  
            topic: topicsArray[0]?.topicChips?.map(x=>x.text) ,
            topicName: topicsArray[0]?.topicName
        }  
    };  
}  


export function convertModuleToUITopicsSingle(moduleTopics) {  
    return [{  
        id: Date.now().toString(), // Unique ID based on current timestamp  
        topicName: moduleTopics?.topicName,  
        topicChips: moduleTopics?.topic?.map((topic, index) => ({  
            id: (Date.now() + index).toString(), // Unique ID based on current timestamp + index  
            text: topic  
        }))  
    }];  
}  
